import { z } from 'zod';
import { objectIdSchema } from './common.js';
/**
 * CLAUDE.md: самостоятельной регистрации нет. Пользователей заводит менеджер
 * через приглашение — это убирает целый класс поверхности атаки.
 */
export const loginSchema = z.object({
    email: z.email(),
    password: z.string().min(1),
    /** Код TOTP. Обязателен для ролей с доступом к порталу. */
    totp: z.string().regex(/^\d{6}$/).optional(),
});
/**
 * Вход водителя: PIN + привязка к устройству.
 * Общий аккаунт на двоих разрушает всю доказательную цепочку —
 * непонятно, кто фактически осматривал машину.
 */
export const driverLoginSchema = z.object({
    phone: z.string().min(6).max(20),
    pin: z.string().regex(/^\d{4,8}$/),
    deviceId: z.string().min(16).max(128),
    deviceName: z.string().max(120).optional(),
});
export const acceptInviteSchema = z.object({
    token: z.string().min(32),
    password: z.string().min(12, 'At least 12 characters'),
    displayName: z.string().min(1).max(120),
});
export const inviteUserSchema = z.object({
    email: z.email(),
    displayName: z.string().min(1).max(120),
    roleId: objectIdSchema,
    siteIds: z.array(objectIdSchema).nullable().default(null),
});
/**
 * Вход от имени пользователя.
 *
 * Основание обязательно и пишется в журнал: поддержка входит под человеком,
 * чтобы воспроизвести его проблему, и организация имеет право знать, кто,
 * когда и зачем это делал. Без основания операция теряет смысл записи.
 */
export const impersonateSchema = z.object({
    targetUserId: objectIdSchema,
    reason: z.string().min(8).max(500),
});
export const selectOrgSchema = z.object({ orgId: objectIdSchema });
export const sessionUserSchema = z.object({
    userId: objectIdSchema,
    orgId: objectIdSchema,
    displayName: z.string(),
    roleKey: z.string(),
    level: z.number().int(),
    grants: z.array(z.object({ capability: z.string(), scope: z.string() })),
    siteIds: z.array(objectIdSchema).nullable(),
    mfaEnabled: z.boolean(),
});
//# sourceMappingURL=auth.js.map